var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPromptIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.48828,
    y: 1.41663,
    width: 15.1667,
    height: 15.1667,
    rx: 5.25,
    stroke: "white",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.09583 7.52496C8.60453 7.52496 8.20625 7.92324 8.20625 8.41454L8.20625 12.95C8.20625 13.4413 8.60453 13.8395 9.09584 13.8395V13.8395C9.58714 13.8395 9.98542 13.4413 9.98542 12.95L9.98542 8.41454C9.98542 7.92324 9.58714 7.52496 9.09583 7.52496V7.52496ZM8.03125 4.85621C8.03125 5.43954 8.5125 5.92079 9.09583 5.92079C9.67917 5.92079 10.1604 5.43954 10.1604 4.85621C10.1604 4.27288 9.67917 3.79163 9.09583 3.79163C8.5125 3.79163 8.03125 4.27288 8.03125 4.85621Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromptIcon);
export default __webpack_public_path__ + "static/media/promptIcon.1fb1979dd2f164c0e89c32506c87a51d.svg";
export { ForwardRef as ReactComponent };